import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import minorityConcentratedBlocksPdf from "../../../../assets/tenders/resource/Minority_Concentrated_Blocks_1228-MCB-Blockpdf-30c692c76198e4f76249db9f0276cd9b.pdf";

const minorityConcentratedBlocksDocuments = [
  {
    serial: 1,
    title: "Minority Concentrated Blocks",
    fileName:
      "Minority_Concentrated_Blocks_1228-MCB-Blockpdf-30c692c76198e4f76249db9f0276cd9b.pdf",
    href: minorityConcentratedBlocksPdf,
  },
];

const MinorityConcentratedBlocks = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      Minority Concentrated Blocks
    </h2>
    <PdfDocumentTable
      documents={minorityConcentratedBlocksDocuments}
      minWidth="680px"
    />
  </section>
);

export default MinorityConcentratedBlocks;